/**
 * Copyright: Copyright (C) 2018 sitb.software,All Rights Reserved
 * author: yyao(873241789@qq.com)
 * date: 2020-09-04
 */
import objectPath from 'object-path';

// 根据六合号码，判断不同的背景颜色
export const filterNumber = (checkNumber) => {
  const redNumber = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
  const blueNumber = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
  const greenNumber = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
  if (redNumber.some(number => number == checkNumber)) return 'number-red';
  if (blueNumber.some(number => number == checkNumber)) return 'number-blue';
  if (greenNumber.some(number => number == checkNumber)) return 'number-green';
  return false;
};

// 连尾的固定号码
export const lianMaWeishu_value = {
  '0尾': '10,20,30,40',
  '1尾': '01,11,21,31,41',
  '2尾': '02,12,22,32,42',
  '3尾': '03,13,23,33,43',
  '4尾': '04,14,24,34,44',
  '5尾': '05,15,25,35,45',
  '6尾': '06,16,26,36,46',
  '7尾': '07,17,27,37,47',
  '8尾': '08,18,28,38,48',
  '9尾': '09,19,29,39,49',
};

/**
 * lianma部分数据
 * @param dataSource   元数据
 * @param shengxiaoData 生肖数据
 * @returns {{data: Array}[]}
 */
export const generateShengxiaoLianmaData = (dataSource, shengxiaoData) => {
  let DEFAULT_LIST = [{data: []}];
  if (dataSource && dataSource.length >= 5) {

    let new_data_erquanzhong_shengxiao = [];
    let new_data_erquanzhong_weishu = [];
    let new_data_techuan_shengxiao = [];
    let new_data_techuan_weishu = [];
    let new_data_erzhongte_shengxiao = [];
    let new_data_erzhongte_weishu = [];
    let new_data_erzhongteX_shengxiao = [];
    let new_data_erzhongteX_weishu = [];

    // 根据生肖分成生肖组
    const generateShengxiaoDataGroup = (dataSource, list) => {
      let DEFAULT_SHENGXIAO_NUMBER_ITEMS = {};
      dataSource.forEach((shengtxiaoItem) => {
        const DEFAULT_sx_item = [];
        shengtxiaoItem.m_number.split(',').forEach(sxItem => {
          const DEFAULT_ITEM = list.find(listItem => {
            const numberClass3 = listItem.class3 < 10 ? `0${listItem.class3}` : listItem.class3;
            return numberClass3 == sxItem;
          });
          DEFAULT_sx_item.push(DEFAULT_ITEM);
        });
        DEFAULT_SHENGXIAO_NUMBER_ITEMS[shengtxiaoItem.sx] = DEFAULT_sx_item;
      });
      return DEFAULT_SHENGXIAO_NUMBER_ITEMS;
    };

    // 寻找生肖组中，最小赔率的那个
    const findShengxiaoMinRate = (dataSource) => {
      return dataSource.reduce((acc, item) => {
        const accOdds = objectPath.get(acc, 'odds');
        const itemOdds = objectPath.get(item, 'odds');
        const newAcc = typeof acc === 'number' ? acc : accOdds;
        return Math.min(newAcc, itemOdds);
      });
    };

    /**
     * 生成这一组生肖，最小的号码赔率
     * @param numbers       生肖号码组
     * @param dataSource    所有的赔率组
     */
    const generateOddsArr = (numbers, dataSource) => {
      // 存储当前生肖 所有号码的赔率
      const oddsArr = {};
      numbers.split(',').forEach(number => {
        let DEFAULT_CLASS3 = '';
        if (dataSource.some(dataListItem => {
          const numberClass3 = dataListItem.class3 < 10 ? `0${dataListItem.class3}` : dataListItem.class3;
          if (numberClass3 == number) {
            DEFAULT_CLASS3 = dataListItem.odds;
            return true;
          }
          return false;
        })) {
          oddsArr[number] = DEFAULT_CLASS3;
        }
      });
      return oddsArr;
    };

    // 生成生肖的结构
    const generateShengxiaoData = (dataSource, dataList) => {
      const DEFAULT_FIRST = objectPath.get(dataList, 0);
      const DEFAULT_FIRST_id = objectPath.get(DEFAULT_FIRST, 'id') || 0;
      const newShengxiaoDataGroup = generateShengxiaoDataGroup(dataSource, dataList);
      const DEFAULT_DATA = [];
      dataSource.forEach((dataItem, index) => {
        // 存储当前生肖 所有号码的赔率
        const oddsArr = generateOddsArr(dataItem.m_number, dataList);
        const minRate = findShengxiaoMinRate(newShengxiaoDataGroup[dataItem.sx], 0);
        DEFAULT_DATA.push({
          ...DEFAULT_FIRST,
          id: `1${DEFAULT_FIRST_id + index}`,
          numberGroup: dataItem.m_number,
          class3: dataItem.sx,
          odds: minRate,
          oddsArr
        })
      });
      return DEFAULT_DATA;
    };
    // 生成尾数所需要的结构
    const generateWeiShuData = (dataList) => {
      const DEFAULT_FIRST = objectPath.get(dataList, 0);
      const DEFAULT_FIRST_id = objectPath.get(DEFAULT_FIRST, 'id') || 0;
      // 组建符合生肖的结构
      const lianmaWeishuArr = [];
      const DEFAULT_data = [];
      Object.keys(lianMaWeishu_value).forEach((item) => {
        lianmaWeishuArr.push({
          m_number: lianMaWeishu_value[item],
          sx: item
        });
      });
      const newShengxiaoDataGroup = generateShengxiaoDataGroup(lianmaWeishuArr, dataList);

      for (let i = 0; i < 10; i++) {
        const weishuLabel = `${i}尾`;
        const minRate = findShengxiaoMinRate(newShengxiaoDataGroup[weishuLabel], 0);
        const oddsArr = generateOddsArr(lianMaWeishu_value[weishuLabel], dataList);

        DEFAULT_data.push({
          ...DEFAULT_FIRST,
          id: `2${DEFAULT_FIRST_id + i}`,
          numberGroup: lianMaWeishu_value[weishuLabel],
          class3: weishuLabel,
          odds: minRate,
          oddsArr
        })
      }
      return DEFAULT_data;
    };

    dataSource.forEach(item => {
      if (item.data.length > 0) {
        if (item.group === '二全中') {
          new_data_erquanzhong_shengxiao = generateShengxiaoData(shengxiaoData, item.data);
          new_data_erquanzhong_weishu = generateWeiShuData(item.data);
        }
        if (item.group === '二中特') {
          new_data_erzhongte_shengxiao = generateShengxiaoData(shengxiaoData, item.data);
          new_data_erzhongte_weishu = generateWeiShuData(item.data);
        }
        if (item.group === '二中特X') {
          new_data_erzhongteX_shengxiao = generateShengxiaoData(shengxiaoData, item.data);
          new_data_erzhongteX_weishu = generateWeiShuData(item.data);
        }
        if (item.group === '特串') {
          new_data_techuan_shengxiao = generateShengxiaoData(shengxiaoData, item.data);
          new_data_techuan_weishu = generateWeiShuData(item.data);
        }
      }
    });
    DEFAULT_LIST = [dataSource[0], dataSource[1], dataSource[2],{
      group: dataSource[3].group,
      data: {
        1: dataSource[3].data,
        2: dataSource[3].data,
        3: new_data_erquanzhong_shengxiao,
        4: new_data_erquanzhong_weishu,
        5: [new_data_erquanzhong_shengxiao, new_data_erquanzhong_weishu],
      }
    }, {
      group: dataSource[4].group,
      data: {
        1: dataSource[4].data,
        2: dataSource[4].data,
        3: new_data_erzhongte_shengxiao,
        4: new_data_erzhongte_weishu,
        5: [new_data_erzhongte_shengxiao, new_data_erzhongte_weishu],
      }
    }, {
      group: dataSource[5].group,
      data: {
        1: dataSource[5].data,
        2: dataSource[5].data,
        3: new_data_erzhongteX_shengxiao,
        4: new_data_erzhongteX_weishu,
        5: [new_data_erzhongteX_shengxiao, new_data_erzhongteX_weishu],
      }
    }, {
      group: dataSource[6].group,
      data: {
        1: dataSource[6].data,
        2: dataSource[6].data,
        3: new_data_techuan_shengxiao,
        4: new_data_techuan_weishu,
        5: [new_data_techuan_shengxiao, new_data_techuan_weishu],
      }
    }];
  }
  return DEFAULT_LIST;
};

// 投注时，需要区分投注时选了多少个号码
export const currentTabKey = {
  1: ['一粒任中'],
  2: ['二肖连中', '二肖连不中', '二尾连中', '二尾连不中', '二全中', '二中特', '二中特X', '特串', '二肖', '二粒任中'],
  3: ['三肖连中', '三肖连不中', '三尾连中', '三尾连不中', '三全中', '三中二', '三中二X', '三肖', '三粒任中'],
  4: ['四肖连中', '四肖连不中', '四尾连中', '四尾连不中', '四不中', '四肖', '四粒任中', '四中一'],
  5: ['五肖连中', '五肖连不中', '五尾连中', '五尾连不中', '五不中', '五肖', '五粒任中', '五中一'],
  6: ['六不中', '六肖', '六中一'],
  7: ['七不中', '七中一'],
  8: ['八不中', '八中一'],
  9: ['九不中', '九中一'],
  10: ['十不中', '十中一'],
  11: ['十一不中'],
  12: ['十二不中']
};


// 获取当前长度
export const lhCurrentTabLength = (class2) => {
  let DEFAULT_LENGTH = 0;
  Object.keys(currentTabKey).some(key => {
    if (currentTabKey[key].some(key => key === class2)) {
      DEFAULT_LENGTH = key;
    }
  });
  return DEFAULT_LENGTH;
};

// 连肖最多可选生肖数
export const LIAN_XIAO_MAX = 7;

// 自选不中可选号码上限：五/六/七不中可多选 1 个，八不中起只能选对应个数
export const buZhongMaxSelect = (playedName) => {
  const min = Number(lhCurrentTabLength(playedName));
  if (!min) return 0;
  if (min <= 7) return min + 1;
  return min;
};

/**
 * 生成数据
 * @param orders      赔率
 * @param radioType   是否是单注 |胆拖
 * @param selectDantuoList  当前玩法胆拖list
 * @returns {Array}
 */
export const lhComputedLm = (orders, radioType, selectDantuoList) => {
  const funs = (number) => list => combine(list, number);
  const key = objectPath.get(orders, '0.played_name');
  const length = lhCurrentTabLength(key);
  const class3List = [];
  orders.map((item, index) => {
    class3List.push(item.class3)
  });
  // 正常玩法
  let res = (length) ? funs(length)(orders.map(item => item.class3)).map(item => {
    const newItemData = getOddItem(item[0], orders);
    return {
      ...newItemData,
      class4: item.join(','),
      class3: class3List.join(','),
      rate: getMinRate(item, orders),
      odds: getMinRate(item, orders),
    };
  }) : orders;
  // 胆拖
  if (radioType == 2) {
    const newLength = length - 1 || 0;
    const dantuoList = [];
    const dantuoKey = [];
    let otherDantuoList = [];
    // 根据选中的胆拖数据，生成胆拖前缀数组
    Object.keys(selectDantuoList).forEach(dantuoItem => {
      dantuoKey.push(dantuoItem);
      dantuoList.push(selectDantuoList[dantuoItem]);
    });
    // 除了胆拖数据外，其他数据的数组，这个需要根据class3 生肖过滤
    otherDantuoList = orders.filter(orderItem => {
      return !dantuoKey.some(key => orderItem.class3 === key);
    });
    const class4 = [];
    const tuoma = [];
    dantuoList.forEach(dantuoItem => class4.push(dantuoItem.class3));
    otherDantuoList.forEach(otherDantuoItem => tuoma.push(otherDantuoItem.class3));
    const newRes = [];
    otherDantuoList.forEach(otherItem => {
      const generateClass4 = `${class4.join(',')},${otherItem.class3}`;
      const generateClass4Arr = generateClass4.split(',');
      newRes.push({
        ...otherItem,
        class4: generateClass4,
        class3: `${class4.join(',')}拖${tuoma.join(',')}`,
        rate: getMinRate(generateClass4Arr, orders),
        odds: getMinRate(generateClass4Arr, orders),
      })
    });
    res = newRes;
  }
  // 生肖、尾数
  if (radioType == 3 || radioType == 4 || radioType == 5) {
    const newOrders = [];
    orders.forEach(order => {
      order.numberGroup.split(',').forEach(numberItem => {
        newOrders.push({
          ...order,
          class3: numberItem
        })
      })
    });
    // 号码去重
    let newOrdersClass3 = newOrders.map(item => item.class3);
    newOrdersClass3 = [...new Set(newOrdersClass3)];

    const COMBINE_DATA = funs(2)(newOrdersClass3);
    res = COMBINE_DATA.map(item => {
      // 截取掉多余参数，并转换id为number类型
      const {numberGroup, oddsArr, money, selected, id, ...other} = orders[0];
      return {
        ...other,
        id: Number(id),
        class4: item.join(','),
        class3: `${class3List[0]}串${class3List[1]}`,
        odds: getMinRate(item, newOrders),
      };
    });
  }
  	//-------------------------------//
	  //一个item为拆出的一组，如1,13,肖自己数、尾自己数不与自己数组合,但肖对尾如果肖自己数又属尾数就要组，例如年肖碰9尾，1,49需包括
	  //排除自己与自己的组合 arr.splice
	 var okarr = new Array();
	if(radioType == 3 || radioType == 4)//生肖对碰 尾数对碰 要排除同尾的组
	{
	 okarr=cleararr(res,radioType);
	}
	else if(radioType == 5)//混合对碰 
	{
		//先识别是肖碰肖还是肖碰尾 或是尾碰尾
		var c3=res[0].class3;
		if(checktype(c3)==0)//0 肖肖 1：肖尾  2：尾尾
		{
			 okarr=cleararr(res,3);
		}
		else if(checktype(c3)==1)//肖尾对碰排除同肖与同尾，但要注意同肖的数但又在要碰的尾数中的数不排除
		{
			var zufirst=res[0].class4.split(",");
			var sxnum=zufirst[0];//生肖第一个数，用来识别这个生肖包含什么数
			var wei=c3.substr(-2,1);//要碰的尾数
			const weishuLabel = `${wei}尾`;
			var weistr=lianMaWeishu_value[weishuLabel];
			var sxarr=getsxnum(sxnum);//生肖arr
			var weiarr=weistr.split(",");//尾数arr
			//for(let i=0,len=sxarr.length;i<len;i++){
				//alert(sxarr[i]);
			//}
			var okarr = new Array();
			
			 for(let i=0,len=res.length;i<len;i++){
				var c4=res[i].class4;
				var c4arr=c4.split(",");
				var notsamesx=sameanimal(c4arr);//两个号不同生肖
				var notsamewei=samewei(c4arr);//两个号不同尾
				var c4=res[i].class4;
				var c4arr=c4.split(",");
				var isok=sxpengwei(c4arr,sxarr,weiarr);
				if(isok)
				 {
					okarr.push(res[i]);
				 }
			 }
		}
		else if(checktype(c3)==2)
		{
			 okarr=cleararr(res,4);
		}
		else
		{
			okarr=res;
		}
	}
	else
	{
		okarr=res;
	}
  return okarr;//得到的分拆所有组 
};
//过滤生肖尾数对碰
function cleararr(res,radioType)
{
	var okarr = new Array();
	 for(let i=0,len=res.length;i<len;i++){
		var c4=res[i].class4;
		var c4arr=c4.split(",");
		if(radioType==3)//生肖对碰
		 {
			var notsame=sameanimal(c4arr);
		 }
		 else if(radioType==4)//尾数对碰
		 {
			var notsame=samewei(c4arr);
		 }
		if(notsame)
		 {
			okarr.push(res[i]);
		 }
	 }
	 return okarr;
}

//通过生肖第一个号码获取这个生肖所有的号码
function getsxnum(sxnum)
{
	sxnum=parseInt(sxnum);
	var sxarr=new Array();
	for(let i=0;i<5;i++)
	{
		var tmp=sxnum+i*12;
		if(tmp<50)
		{
			sxarr.push(tmp);
		}
	}
	return sxarr;
}
//计算混合对碰有多少个尾字，用来识别具体是什么碰什么
function checktype(str)
{
	var result = str.match(/尾/g);
	var size = (result || []).length
	return size;//0 肖肖 1：肖尾  2：尾尾
}

//判断两个号码是否同一个生肖
function sameanimal(arr)
{
	var cha=arr[1]-arr[0];
	if (cha%12==0)//两个号同生肖
	{
		return false;
	}
	else
	{
		return true;
	}
}
//判断两个号码是否同尾
function samewei(arr)
{
	var cha=arr[1]-arr[0];
	if (arr[1]%10==arr[0]%10)//两个号同尾
	{
		return false;
	}
	else
	{
		return true;
	}
}
//同尾排除，同肖但又不在尾的排除
function sxpengwei(arr,sxarr,weiarr)
{
	var re=true;
	var cha=parseInt(arr[1])-parseInt(arr[0]);
	var cha=cha+48;
	if (arr[1]%10==arr[0]%10)//两个号同尾并且两个号都不在生肖中才排除
	{
			if(!in_array(arr[0],sxarr) && !in_array(arr[1],sxarr))
			{
			re=false;
			}
	}
	if (cha%12==0)//两个号同生肖  并且两个号都不在尾数中才排除
	{
		//同肖数而且两个数都不在尾数的数组中排除
		var wei0=arr[0];
		if(wei0<10)
		{
			var wei0='0'+arr[0];
		}
		var wei1=arr[1];
		if(wei1<10)
		{
			var wei1='0'+arr[1];
		}
		if(!in_array(wei0,weiarr) && !in_array(wei1,weiarr))
		{
			re=false;
		}
	}
	//
	return re;
}
function in_array(search,array){
    for(let i=0,len=array.length;i<len;i++)
	{
        if(array[i]==search){
            return true;
        }
    }
    return false;
}
//-------------------//

function combine(arr, num) {
  const r = [];
  (function f(t, a, n) {
    if (n == 0) {
      let PUSH_ARR = t;
      // 这里是比较号码，小的排前面，过滤掉生肖尾数、转换成号码对比
      if(Array.isArray(t) && t.length >= 2 && !isNaN(Number(t[0]))){
        PUSH_ARR = PUSH_ARR.map(x => Number(x));
        PUSH_ARR.sort(function(a,b){return a>b?1:-1});
      }
      return r.push(PUSH_ARR);
    }
    for (let i = 0, l = a.length; i <= l - n; i++) {
      f(t.concat(a[i]), a.slice(i + 1), n - 1);
    }
  })([], arr, num);
  return r;
}

function getOddItem(class3, oddsArr) {
  const findItem = oddsArr.find(dataItem => dataItem.class3 == class3);
  if (findItem === -1) {
    return [];
  }
  return findItem;
}

// 获取当前item的最小费率
export function getMinRate(checkKey, dataSource) {
  // 存储符合要求的数据item
  let default_check_arr = [];
  // 获取当前相连的item
  checkKey.forEach(checkItem => {
    const findItem = getOddItem(checkItem, dataSource);
    if (findItem !== -1) {
      // 正常玩法直接取findItem odds，但是设计到生肖 尾数的玩法，当前行包含五六个数字，把当前的odd 按照{number: odd}的形式存在了 oddsArr中
      const odds = objectPath.get(findItem, `oddsArr.${checkItem}`) || findItem.odds;
      default_check_arr.push(odds);
    }
  });
  // 找到最小费率，连肖连尾连码都取组合最低赔率
  const default_rate = default_check_arr.reduce((arr, item) => {
    return Math.min(arr, item);
  });
  return default_rate || 0;
}



// WEBPACK FOOTER //
// ./src/utils/lhMethods.js